import { GameObject } from "./GameObject";
import { SpineAnimator } from "./SpineAnimator";

type IdleAnimData = {
	loops: number;
	currentLoop: number;
	idle: string;
	anims: string[];
};

export default class CharacterAnimator extends SpineAnimator {
	protected idleAnim?: IdleAnimData;

	constructor(obj: GameObject, config: SpineGameObjectConfig) {
		super(obj, config);
	}

	play(animationName: string, loop?: boolean, ignoreIfPlaying?: boolean): void {
		if (this.idleAnim) {
			this._spine.off(SpineAnimator.ANIMATION_COMPLETE, this.onIdleLoop, this);
			this._spine.off(SpineAnimator.ANIMATION_COMPLETE, this.resumeIdle, this);
			this.idleAnim = undefined;
		}
		super.play(animationName, loop, ignoreIfPlaying);
	}

	playIdle(idleAnim: string, loops: number, anims: string[]): void {
		this._spine.play(idleAnim, true);
		this.idleAnim = {
			idle: idleAnim,
			currentLoop: 0,
			loops: loops,
			anims: anims,
		};
		this._spine.on(SpineAnimator.ANIMATION_COMPLETE, this.onIdleLoop, this);
	}

	private onIdleLoop(): void {
		if (this.idleAnim && this._spine.getCurrentAnimation().name == this.idleAnim.idle) {
			this.idleAnim.currentLoop++;
			if (this.idleAnim.currentLoop >= this.idleAnim.loops) {
				this.idleAnim.currentLoop = 0;
				this._spine.play(Phaser.Math.RND.pick(this.idleAnim.anims), false);
				this._spine.once(SpineAnimator.ANIMATION_COMPLETE, this.resumeIdle, this);
			}
		}
	}

	private resumeIdle(): void {
		if (this.idleAnim) this._spine.play(this.idleAnim.idle, true);
	}
}
